export default {
  updateSupplier(state, payload) {
    state.supplier = payload;
  },

  updateSupplierArchived(state, payload) {
    state.supplierArchived = payload;
  },

  updateDealers(state, payload) {
    state.dealers = payload;
  },

  updateDealersArchived(state, payload) {
    state.dealersArchived = payload;
  },

  updateReclamation(state, payload) {
    state.reclamation = payload;
  },

  updateParams(state, payload) {
    state.params[payload.key] = payload.val;
  },

  updateAllParams(state, payload) {
    state.params = payload;
  },

  updateStatuses(state, payload) {
    state.statuses = payload;
  },

  updatePagination(state, payload) {
    state.pagination = payload;
  },

  updateSearch(state, payload) {
    state.search = payload; 
  }
}
